import React from 'react';
import { Dialog as MuiDialog } from '@mui/material';

const AppDialog = ({ onClose, ...props }) => {
    const handleClose = (event, reason) => {
        if (reason === 'backdropClick') return;
        if (onClose) onClose(event, reason);
    };

    return <MuiDialog {...props} onClose={handleClose} />;
};

export default AppDialog;
